import { useMutation } from 'react-query';

import { setTableColumns as mutationFn } from 'api/endPoints/setTableColumns';

export const useMutationSetTableColumns = () => {
    return useMutation<
        unknown,
        QueryError,
        {
            columnOrder: string[];
            hiddenColumns: string[];
            componentKey: string;
        }
    >((params) => mutationFn(params));
};
